import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.93934 1.93934L9.58579 2.29289V2.29289L9.93934 1.93934ZM11 3L11.3536 2.64645V2.64645L11 3ZM12.0607 4.06066L11.7071 4.41421L11.7071 4.41421L12.0607 4.06066ZM12 7.5C12 7.77614 12.2239 8 12.5 8C12.7761 8 13 7.77614 13 7.5H12ZM8 15C8.27614 15 8.5 14.7761 8.5 14.5C8.5 14.2239 8.27614 14 8 14V15ZM4 13V3H3V13H4ZM5 2H8.87868V1H5V2ZM9.58579 2.29289L10.6464 3.35355L11.3536 2.64645L10.2929 1.58579L9.58579 2.29289ZM10.6464 3.35355L11.7071 4.41421L12.4142 3.70711L11.3536 2.64645L10.6464 3.35355ZM12 5.12132V7.5H13V5.12132H12ZM8 14H5V15H8V14ZM11.7071 4.41421C11.8946 4.60175 12 4.8561 12 5.12132H13C13 4.59089 12.7893 4.08218 12.4142 3.70711L11.7071 4.41421ZM8.87868 2C9.1439 2 9.39825 2.10536 9.58579 2.29289L10.2929 1.58579C9.91782 1.21071 9.40911 1 8.87868 1V2ZM3 13C3 14.1046 3.89543 15 5 15V14C4.44772 14 4 13.5523 4 13H3ZM4 3C4 2.44772 4.44772 2 5 2V1C3.89543 1 3 1.89543 3 3H4Z"
            fill="currentColor"
        />
        <path
            d="M12.5 5.5H10C9.17157 5.5 8.5 4.82843 8.5 4V1.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.5 11.5L10 13L13 10"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
